export default __webpack_public_path__ + "static/media/abstract.a29b6d4d.jpg";